import React from 'react'
import {
    ImageBanner,
    ImageBannerProps,
} from '../../banners/ImageBanner/ImageBanner'
import { createRegisterableComponent } from '@news-mono/web-common'

export const ImageBannerRegistration = createRegisterableComponent(
    'image-banner',
    (props: ImageBannerProps) => <ImageBanner {...props} />,
)
